export default __webpack_public_path__ + "static/peek-a-phone-afffef181e1363a546e3a5d7da9bbc0b.png";